"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NAME_COOKIE_OF_SAVED_OFFERS_TO_CLAIM = exports.NAME_COOKIE_OF_SAVED_OFFERS_2_BASKET = exports.BOOKING_UI_KEY = void 0;
var BOOKING_UI_KEY = exports.BOOKING_UI_KEY = 'BOOKING_UI_KEY';
var NAME_COOKIE_OF_SAVED_OFFERS_TO_CLAIM = exports.NAME_COOKIE_OF_SAVED_OFFERS_TO_CLAIM = '__NAME_OF_SAVED_OFFERS_TO_CLAIM__';
var NAME_COOKIE_OF_SAVED_OFFERS_2_BASKET = exports.NAME_COOKIE_OF_SAVED_OFFERS_2_BASKET = '__NAME_COOKIE_OF_SAVED_OFFERS_2_BASKET__';